module.exports = __webpack_public_path__ + "img/oneills_logo_white_2023_small@2x.60d077da.png";